import React from "react";
import { useQuickSightTrustedAdvisor } from "@/hooks/useTrustedAdvisorReports";
import AWSReportsTemplate from "@/components/templates/AWSReportsTemplate";
import QuickSightAwsTrustedAdvisorDashboard from "@/components/organisms/TrustedAdvisorDashboard";

function TrustedAdvisorReports() {
  const { embedUrl, loading, error, refetch } = useQuickSightTrustedAdvisor();

  return (
    <AWSReportsTemplate
      title="AWS Trusted Advisor Organizational Dashboard"
      loading={loading}
      error={error}
      onRetry={refetch}
      hideFilters={true}
      hideDownload={true}
    >
      <QuickSightAwsTrustedAdvisorDashboard />
    </AWSReportsTemplate>
  );
}

export default TrustedAdvisorReports;
